import api from "../../utils/axios";
import { BULK_ORDER_OPERATIONS_ENDPOINTS } from "./endpoints";
import {
	BulkOrderOperationResponse,
	BulkStatusUpdatePreflight,
	BulkStatusUpdateRequest,
} from "./types";

/**
 * Classifies the batch (local / outbound / inbound) before the operator picks anything.
 * 400s with a `groups` breakdown when the batch mixes kinds.
 */
export const preflightBulkStatusUpdate = async (
	orderIds: number[]
): Promise<BulkStatusUpdatePreflight> => {
	const response = await api.post<BulkStatusUpdatePreflight>(
		BULK_ORDER_OPERATIONS_ENDPOINTS.statusUpdatePreflight,
		{ orderIds }
	);
	return response.data;
};

export const executeBulkStatusUpdate = async (
	body: BulkStatusUpdateRequest
): Promise<BulkOrderOperationResponse> => {
	const response = await api.post<BulkOrderOperationResponse>(
		BULK_ORDER_OPERATIONS_ENDPOINTS.statusUpdate,
		body
	);
	return response.data;
};
